import { Action } from '@ngrx/store';
import * as SearchTypes from './search-results.types'

export class FetchSearchResultsRequest implements Action {
    readonly type = SearchTypes.FETCH_SEARCH_RESULTS_REQUEST;
    constructor(public params: any) { }
}

export class FetchSearchResultsSuccess implements Action {
    readonly type = SearchTypes.FETCH_SEARCH_RESULTS_SUCCESS;
    constructor(public payload: any) { }
}

export class FetchSearchResultsFailure implements Action {
    readonly type = SearchTypes.FETCH_SEARCH_RESULTS_FAILURE;
    constructor(public payload: any) { }
}


export class UpdateField implements Action {
    readonly type = SearchTypes.UPDATE_FIELD;
    public constructor(public field: string, public value: any, public path: string) { }
}

export class SetDefaultData implements Action {
    readonly type = SearchTypes.SET_DEFAULT_DATA;
    public constructor(public path: string) { }
}


export type Actions =
    FetchSearchResultsSuccess | FetchSearchResultsFailure | FetchSearchResultsRequest |
    SetDefaultData | UpdateField;
